window.getLiked = function getLiked(cars = null) {
    const savedCars = JSON.parse(localStorage.getItem('savedCars'));

    if (savedCars) {

        $.each(savedCars, function (index, carId) {
            const car = $("#save-" + carId);

            if (!car.hasClass("js_removeComparedCar")) {
                car.removeClass("js_saveCar");
                car.addClass("js_dislike");
            }
        });

        updateSavedCarsCount(cars ? cars : savedCars);
    }
}

window.updateSavedCarsCount = function updateSavedCarsCount(cars) {
    const heartCount = $(".colIcon.heart").find("div");

    if (cars.length > 0) {
        heartCount.addClass("active");
        heartCount.text(cars.length);
    } else {
        heartCount.removeClass("active");
        heartCount.text(0);
    }
}

$(document).ready(function () {
    'use strict';

    // Save Cars
    const savedCarsCount =  $(".savedCarsTitle span");
    const noResults = $(".savedCarsWrapper .noResults");
    const noResultsCompared = $(".comparedCarsWrapper .noResults");
    const savedCarsContainer = $("#savedCars");

    function getSavedCars(cars) {
        const loading = $(".savedCarsWrapper #loadingOverlay");

        loading.fadeIn();

        $.ajax({
            type: 'get',
            url: '/sites/petervardy/templates/ajax/get-saved-cars.php?ajax=true&checkStock=1&savedCars=' + cars,
            success: function (response) {
                const result = JSON.parse(response);
                const count = result.count;
                const comparedCars = JSON.parse(localStorage.getItem('comparedCars'));

                if (count > 0) {
                    noResults.hide()

                } else {
                    noResults.show();
                }

                savedCarsContainer.html(result.body);
                savedCarsCount.text(count);

                if (comparedCars) {
                    getCheckedCars();
                }

                getLiked();
                storefrontPopup();

                loading.fadeOut();
            }
        });
    }

    const savedCars = JSON.parse(localStorage.getItem('savedCars'));
    let carsArray = [];

    if (savedCars) {
        carsArray = savedCars;
    }

    if (savedCarsContainer.length > 0 && carsArray) {
        getSavedCars(carsArray);
    }

    $(document).on('click', '.js_saveCar', function (e) {
        e.preventDefault();

        const carId = $(this).data("id");

        if (!carsArray.includes(carId)) {
            carsArray.push(carId);
        }

        localStorage.setItem("savedCars", JSON.stringify(carsArray));

        $(this).removeClass('js_saveCar');
        $(this).addClass('js_dislike');

        updateStickyFloat(carsArray);
        updateSavedCarsCount(carsArray);

        if (carsArray.length === 0) {
            noResults.show();
        } else {
            noResults.hide();
        }
    });

    $(document).on('click', '.js_removeCar', function (e) {
        e.preventDefault();

        const carId = $(this).data("id");
        const index = carsArray.indexOf(carId);
        const indexCompare = comparedCarsArray.indexOf(carId);

        if (index > -1) {
            carsArray.splice(index, 1);
            $(this).closest(".vehicleCard").remove();
            savedCarsCount.text(savedCarsCount.text() - 1);
        }

        if (indexCompare > -1) {
            comparedCarsArray.splice(index, 1);

            compareContainer(comparedCarsArray);
        }

        localStorage.setItem("savedCars", JSON.stringify(carsArray));

        updateStickyFloat(carsArray);
        updateSavedCarsCount(carsArray);

        if (carsArray.length === 0) {
            noResults.show();
        } else {
            noResults.hide();
        }
    });

    $(document).on('click', '.js_removeComparedCar', function (e) {
        e.preventDefault();

        const carId = $(this).data("id");
        const indexCompare = comparedCarsArray.indexOf(carId);

        if (indexCompare > -1) {
            comparedCarsArray.splice(indexCompare, 1);
            $(this).closest(".compareCar").remove();
            compareContainer(comparedCarsArray);
        }

        if (comparedCarsArray.length === 0) {
            noResultsCompared.show();
        } else {
            noResultsCompared.hide();
        }
    });

    function updateStickyFloat(cars) {
        $(".stickySaved span").text(cars.length);
        $(".stickySaved").fadeIn();

        setTimeout(function() {
            $(".stickySaved").fadeOut();
        }, 3000);
    }

    if (!window.location.href.includes("saved-cars")) {
        $(document).on('click', '.js_dislike', function (e) {
            e.preventDefault();

            const carId = $(this).data("id");
            const index = carsArray.indexOf(carId);
            const indexCompare = comparedCarsArray.indexOf(carId);

            if (index > -1) {
                carsArray.splice(index, 1);
            }

            if (indexCompare > -1) {
                comparedCarsArray.splice(index, 1);
            }

            localStorage.setItem("comparedCars", JSON.stringify(comparedCarsArray));
            localStorage.setItem("savedCars", JSON.stringify(carsArray));

            $(this).removeClass('js_dislike');
            $(this).addClass('js_saveCar');
            $(this).find("img").attr("src", "/sites/petervardy/images/icons/Heart.svg");

            updateStickyFloat(carsArray);
            updateSavedCarsCount(carsArray);

            if (carsArray.length === 0) {
                noResults.show();
            } else {
                noResults.hide();
            }
        });
    }

    // Compare Cars

    const comparedCars = JSON.parse(localStorage.getItem('comparedCars'));
    const comparePanel = $(".compareContainer");
    const compareButtonCount = $(".compareContainer span");
    let comparedCarsArray = [];

    if (comparedCars) {
        comparedCarsArray = comparedCars;
    }

    $(document).on('click', '.js_compareCar', function (e) {
        const carId = parseInt($(this).val());
        const comparedCars = JSON.parse(localStorage.getItem('comparedCars'));

        let comparedCarsArray = [];

        if (comparedCars) {
            comparedCarsArray = comparedCars;
        }

        if ($(this).is(":checked")) {

            if (comparedCarsArray.length >= 4) {
                e.preventDefault();
            } else {

                if (!comparedCarsArray.includes(carId)) {
                    comparedCarsArray.push(carId);

                    compareContainer(comparedCarsArray);
                }
            }
        } else {
            const index = comparedCarsArray.indexOf(carId);

            if (index > -1) {
                comparedCarsArray.splice(index, 1);
            }

            compareContainer(comparedCarsArray);
        }
    });

    $(document).on('click', '.js_clearSelected', function (e) {
        compareButtonCount.text(0);
        $('.js_compareCar').prop("checked", false);
        $(".js_compareCar").closest(".checkbox").next().hide();
        $(".js_compareCar").closest(".checkbox").show();

        localStorage.setItem("comparedCars", JSON.stringify([]));

        comparePanel.fadeOut();
    });

    function compareContainer(comparedCarsArray) {
        compareButtonCount.text(comparedCarsArray.length);

        if (comparedCarsArray.length > 0) {
            comparePanel.fadeIn();
        } else {
            comparePanel.fadeOut();
        }

        hideOtherCheckboxes(comparedCarsArray);

        localStorage.setItem("comparedCars", JSON.stringify(comparedCarsArray));
    }

    function hideOtherCheckboxes(cars) {
        var checkboxes = $(".js_compareCar").closest(".checkbox");

        if (cars.length >= 4) {
            checkboxes.next().show();
            checkboxes.hide();
            $(".js_compareCar:checked").closest(".checkbox").next().hide();
            $(".js_compareCar:checked").closest(".checkbox").show();
        } else {
            checkboxes.next().hide();
            checkboxes.show();
        }
    }

    function getCheckedCars() {

        if (comparedCarsArray.length > 0) {
            $.ajax({
                type: 'get',
                url: '/sites/petervardy/templates/ajax/get-compared-cars.php?ajax=true&checkCompared=1&cars=' + comparedCarsArray,
                success: function (response) {
                    const result = JSON.parse(response);
                    const availableCars = result.available_cars;

                    $.each(availableCars, function(index, carId) {
                        $("#compare-" + carId).prop("checked", true);
                    });

                    compareButtonCount.text(availableCars.length);

                    if (availableCars.length > 0) {
                        comparePanel.fadeIn();
                    } else {
                        comparePanel.fadeOut();
                    }

                    hideOtherCheckboxes(availableCars);

                    localStorage.setItem("comparedCars", JSON.stringify(availableCars));
                }
            });
        }
    }

    var unavailableMsg = $(".js_removeUnavailable");

    if (unavailableMsg.length > 0) {
        unavailableMsg.click(function() {
            $.ajax({
                type: 'get',
                url: '/sites/petervardy/templates/ajax/get-saved-cars.php?ajax=true&closeUnavailable=1&cars=' + carsArray,
                success: function (response) {
                    const result = JSON.parse(response);

                    localStorage.setItem("savedCars", JSON.stringify(result.available_cars));

                    unavailableMsg.parent().removeClass("active");
                }
            });
        });
    }

    $.ajax({
        type: 'get',
        url: '/sites/petervardy/templates/ajax/get-saved-cars.php?ajax=true&checkStock=1&savedCars=' + carsArray,
        success: function (response) {
            const result = JSON.parse(response);
            const count = result.count;
            const availableCars = result.availableCars;
            const sold = parseInt(result.sold);

            if (sold === 1) {
                $(".unavailableVehicles").addClass("active");
            }

            if (count > 0) {
                getLiked(availableCars);
            }
        }
    });
});
